
  import { Vue, Component } from 'vue-property-decorator'
  import ChangePassword from '../components/ChangePassword.vue'
  import ChangeProfile from '../components/ChangeProfile.vue'

  @Component({
    components: { ChangePassword, ChangeProfile }
  })
  export default class MyUser extends Vue {}
